import React from 'react';
import { Box, Typography } from '@mui/material';

/** Title row at the top of every dashboard page: title, optional subtitle, and actions on the right. */
const PageHeader = ({ title, subtitle, actions, sx }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      mb: 3,
      ...sx,
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>{actions}</Box>}
  </Box>
);

export default PageHeader;
